import React from 'react';
import MainLayout from '../../layout/MainLayout';
import Sidebar from '../../components/SidebarArea';
import ContentArea from '../../components/ContentArea';

const HeatingFormStepper = (): JSX.Element => {

	return (
		<MainLayout>
			<MainLayout.SidebarArea>
				<Sidebar />
			</MainLayout.SidebarArea>
			<MainLayout.Content>
				<ContentArea />
			</MainLayout.Content>
		</MainLayout>
	);
};

export default HeatingFormStepper;
